import {Component, DestroyRef, DoCheck, Input, OnInit} from '@angular/core';
import {CommonModule, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {FeatureViewerItemLookup} from '../../../../../common/models/feature-viewer-item.model';
import {NgEventBus} from 'ng-event-bus';
import {LookupService} from '../../../../../common/service/lookup.service';
import {PlanModelService} from '../../../../../common/service/plan-model.service';
import {TraitsService} from '../../../../../common/service/traits.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FeatureBusinessTableComponent} from './feature-business-table/feature-business-table.component';
import {NLR_TABS} from '../../../../../common/constants';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Component({
    selector: 'nlr-survey-tab',
    imports: [CommonModule, FormsModule, FeatureBusinessTableComponent],
    providers: [CommonModule],
    templateUrl: './survey-tab.component.html',
    styleUrl: './survey-tab.component.scss'
})
export class SurveyTabComponent implements OnInit, DoCheck {
    @Input()
    editorConfig: any;

    @Input()
    disabled: boolean;

    @Input()
    selectedTab: NLR_TABS;

    title = 'SurveyTabComponent';

    selectedFeatureTableTool: FeatureViewerItemLookup;

    toolRows: [{tools: FeatureViewerItemLookup[]}] = [{tools: []}];

    isDesignTabActive: boolean = true;

    previousSelectedTab: NLR_TABS = undefined;

    constructor(
        private destroyRef: DestroyRef,
        private eventBus: NgEventBus,
        private lookupService: LookupService,
        private planModelService: PlanModelService,
        private traitsService: TraitsService
    ) {}

    ngOnInit() {
        this.eventBus
            .on('traitsChanged')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                if (!this.planModelService.getModel().planPurpose || !this.planModelService.getModel().surveyMethod) {
                    return;
                }

                this.populateTools();
            });

        this.populateTools();
    }

    ngDoCheck(): void {
        if (this.selectedTab !== this.previousSelectedTab) {
            this.previousSelectedTab = this.selectedTab;
            this.isDesignTabActive = this.selectedTab === NLR_TABS.DESIGN;
        }
    }

    changeSelectedFeatureTableTool(tool: any) {
        console.debug(`${this.title} - changeSelectedFeatureTableTool`);
        this.selectedFeatureTableTool = tool;
        this.eventBus.cast(`moveTo${this.selectedFeatureTableTool.type}FeaturesExtent`);
    }

    populateTools() {
        console.debug(`${this.title} - populateTools`);

        const featureViewerItemLookups = this.lookupService
            .getLookups('featureViewerItem')
            .filter((l: FeatureViewerItemLookup) => l.view === 'survey' && this.traitsService.criteriaMatches(l.planTraitCriteria, true))
            .sort((a: FeatureViewerItemLookup, b: FeatureViewerItemLookup) => {
                if (a.row === b.row) {
                    return a.order - b.order;
                }
                return a.row - b.row;
            });

        this.toolRows.splice(0, this.toolRows.length, {tools: []});

        featureViewerItemLookups.forEach((tool: FeatureViewerItemLookup) => {
            if (this.toolRows.length >= tool.row) {
                this.toolRows[tool.row - 1].tools.push(tool);
            } else {
                this.toolRows.push({tools: [tool]});
            }

            // set the default selection
            if (tool.defaultSelection) {
                this.selectedFeatureTableTool = tool;
            }
        });
    }
}
